import { Component, OnInit } from '@angular/core';

import { AuthService } from '../auth/auth.service';
import { WidgetType } from '../scorecard/core/template-definition.model';

import { AGENT } from './insight-new.constant';

@Component({
    selector: '[cmpsInsightNew]',
    templateUrl: './insight-new.component.html',
})
export class InsightNewComponent implements OnInit {
    /** @private */ _options: string[];
    /** @private */ insightUser: number;
    /** @private */ widgetType = WidgetType;
    /** @private */ isAgentRole: boolean;

    constructor(private readonly _authService: AuthService) {}

    ngOnInit(): void {
        this.isAgentRole = this._authService.user.roleId === AGENT;
    }
}
